import React from "react";
import DataTableView from "app/shared/components/data-table/data-table.web";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import { useTranslation } from "react-i18next";
import { ITEMTRANSACTIONAUTO } from "app/shared/services/services-model.type";
import { Block } from "app/shared/components/blocks/block";
import EmptyBox from "app/shared/components/empty-box/empty-box";
import { FlatList, ListRenderItem, StyleSheet } from "react-native";
import { Constant } from "app/shared/constant/constant";
import { Paragraph, TouchableRipple, useTheme } from "react-native-paper";
import { spacing } from "app/shared/styles/spacing";

export interface DataAutoToUpHistoryTableProps {
  accountno?: string; //Số tài khoản thanh toán
  billno?: string; //Số điện thoại topup/ Mã billing
  amount?: string; //Mệnh giá/ số tiền thanh toán
  status?: string; //Mã trạng thái thanh toán
  trandesc?: string; //Mô tả trạng thái
  trandate?: string; //Ngày thực hiện (format yyyyMMdd HH:mm:SS)
  responsecode?: string; //Mã code
  responsedesc?: string; //Mô tả mã code
  cif?: string; //Mã khách hàng
  tranrescode?: string; //Mã kết quả giao dịch trả về
  tranresdes?: string; //Mô tả kết quả giao dịch trả về
  provider?: string; //Nhà cung cấp
  services?: string; //Dịch vụ
  id?: string;
  FORMAT_TRANS_DATE?: string;
  CURRENCY_AMOUNT?: string;
}

interface TransactionTableProps {
  onChangeData: (data: ITEMTRANSACTIONAUTO[]) => void;
  data?: DataAutoToUpHistoryTableProps[];
  isShow?: boolean;
}

function AutoTopUpTransactionTable(props: TransactionTableProps) {
  const { t } = useTranslation();
  const isDesktop = useDesktopMediaQuery();
  const { colors, fonts } = useTheme();

  const { data = [], onChangeData, isShow = false } = props;
  const [dataTable, setDataTable] = React.useState<DataAutoToUpHistoryTableProps[]>([]);
  const [arrayExpand, setArrayExpand] = React.useState<Array<boolean>>([]);

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        displayShow: { display: isShow ? "flex" : "none" },
        textBold: { ...fonts.medium, color: colors.text, paddingVertical: 0 },
        text: { ...fonts.regular, color: colors.text, paddingVertical: 0 },
        label: { flex: 1, minWidth: "30%" },
        value: { textAlign: "right" },
      }),
    [colors.text, fonts.medium, fonts.regular, isShow],
  );

  const onPressExpand = (_index: number) => {
    const _arrayExpand: Array<boolean> = [];
    arrayExpand.forEach((value, index) => {
      let status: boolean = false;
      if (index === _index) status = !value;
      _arrayExpand.push(status);
      return value;
    });
    console.log("_arrayExpand new: ", _arrayExpand);
    setArrayExpand(_arrayExpand);
  };

  React.useEffect(() => {
    onChangeData(dataTable);
    const _arrayExpand: Array<boolean> = [];
    dataTable.forEach((_item) => {
      _arrayExpand.push(false);
    });
    setArrayExpand(_arrayExpand);
  }, [dataTable, onChangeData]);

  React.useEffect(() => {
    setDataTable(data || []);
  }, [data]);

  const renderItemDetail: ListRenderItem<DataAutoToUpHistoryTableProps> = ({ item, index }) => (
    <React.Fragment>
      <TouchableRipple key={`${item.id}` + index} onPress={() => onPressExpand(index)}>
        <Block pv={spacing.small} ph={spacing.medium} bg={index % 2 === 0 ? colors.surface : colors.backgroundForm} br={8}>
          <Block row spaced>
            <Paragraph style={[styles.textBold, styles.label]}>{t("AUTO_BILLING_THOI_GIAN_GIAO_DICH")}</Paragraph>
            <Paragraph style={[styles.textBold, styles.value]}>{item.FORMAT_TRANS_DATE}</Paragraph>
          </Block>
          <Block row spaced>
            <Paragraph style={[styles.text, styles.label]}>{t("AUTO_TOPUP_MENH_GIA")}</Paragraph>
            <Paragraph style={[styles.text, styles.value]}>{item.CURRENCY_AMOUNT}</Paragraph>
          </Block>
          <Block row spaced>
            <Paragraph style={[styles.text, styles.label]}>{t("ACC_TRANG_THAI")}</Paragraph>
            <Paragraph style={[styles.text, styles.value]}>{item.responsedesc}</Paragraph>
          </Block>
          {item?.responsecode?.length && !["E00", "00"].includes(item.responsecode) && item.tranresdes?.length ? (
            <Block row spaced>
              <Paragraph style={[styles.text, styles.label]}>{t("AUTO_BILLING_GHI_CHU")}</Paragraph>
              <Paragraph style={[styles.text, styles.value]}>{item.tranresdes}</Paragraph>
            </Block>
          ) : (
            <></>
          )}
        </Block>
      </TouchableRipple>
    </React.Fragment>
  );

  const renderMobile = (
    <FlatList data={dataTable} keyExtractor={(_item) => String(_item.id)} renderItem={renderItemDetail} initialNumToRender={10} />
  );

  return (
    <Block style={styles.displayShow}>
      {isDesktop ? (
        <DataTableView
          header={[
            {
              name: "#",
              attr: "id",
            },
            {
              name: t("AUTO_BILLING_THOI_GIAN_GIAO_DICH"),
              attr: "FORMAT_TRANS_DATE",
            },
            {
              name: t("AUTO_TOPUP_MENH_GIA"),
              attr: "CURRENCY_AMOUNT",
              isCustomDataColumn: true,
              type: Constant.AMOUNT,
            },
            {
              name: t("ACC_TRANG_THAI"),
              attr: "responsedesc",
            },
            {
              name: t("AUTO_BILLING_GHI_CHU"),
              attr: "tranresdes",
              notCenter: true,
            },
          ]}
          dataTable={dataTable}
          widthCell={!isDesktop ? 120 : undefined}
        />
      ) : (
        renderMobile
      )}
      {isShow && data.length === 0 ? <EmptyBox title={t("ACC_KHONG_CO_GIAO_DICH_NAO")} /> : <></>}
    </Block>
  );
}

export default AutoTopUpTransactionTable;
